import React from "react";

const VariantSelectors = ({
  sizes = [],
  colors = [],
  selectedSize = "",
  selectedColor = "",
  onSizeChange = () => {},
  onColorChange = () => {},
  sizeLabel = "Size",
  colorLabel = "Color",
  disabled = false,
  allLabel = "",
  compact = false,
  className = "",
}) => {
  const sizeOptions = sizes.filter(Boolean);
  const colorOptions = colors.filter(Boolean);
  const selectClasses = compact
    ? "min-w-[72px] max-w-[120px] w-auto rounded-[6px] border border-white/15 bg-transparent px-2 py-1.5 text-[12px] font-semibold text-white outline-none transition hover:border-cynos-red focus:border-cynos-red disabled:cursor-not-allowed disabled:opacity-50"
    : "w-full rounded-[8px] border border-white/15 bg-cynos-surface px-3 py-3 text-sm text-white outline-none transition hover:border-white/30 disabled:cursor-not-allowed disabled:opacity-50";

  if (compact) {
    return (
      <div className={className}>
        <div className="flex flex-wrap items-center gap-3 text-[10px] uppercase tracking-[0.2em] text-zinc-400">
          {sizeOptions.length > 0 && (
            <div className="inline-flex items-center gap-2 rounded-[6px] border border-white/10 bg-[#111] px-2 py-1">
              <span className="whitespace-nowrap text-[10px] uppercase tracking-[0.22em] text-zinc-400">{sizeLabel}:</span>
              <select
                aria-label={sizeLabel}
                value={selectedSize}
                onChange={(event) => onSizeChange(event.target.value)}
                disabled={disabled}
                className={selectClasses}
              >
                <option value="" disabled>
                  {allLabel || sizeLabel}
                </option>
                {sizeOptions.map((size) => (
                  <option key={size} value={size} className="bg-[#111] text-white">
                    {size}
                  </option>
                ))}
              </select>
            </div>
          )}

          {colorOptions.length > 0 && (
            <div className="inline-flex items-center gap-2 rounded-[6px] border border-white/10 bg-[#111] px-2 py-1">
              <span className="whitespace-nowrap text-[10px] uppercase tracking-[0.22em] text-zinc-400">{colorLabel}:</span>
              <select
                aria-label={colorLabel}
                value={selectedColor}
                onChange={(event) => onColorChange(event.target.value)}
                disabled={disabled}
                className={selectClasses}
              >
                <option value="" disabled>
                  {allLabel || colorLabel}
                </option>
                {colorOptions.map((color) => (
                  <option key={color} value={color} className="bg-[#111] text-white">
                    {color}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={className}>
      <div className="grid gap-3 sm:grid-cols-2">
        {sizeOptions.length > 0 && (
          <label className="block">
            <span className="sr-only">{sizeLabel}</span>
            <select
              aria-label={sizeLabel}
              value={selectedSize}
              onChange={(event) => onSizeChange(event.target.value)}
              disabled={disabled}
              className={selectClasses}
            >
              <option value="" disabled>
                {allLabel || sizeLabel}
              </option>
              {sizeOptions.map((size) => (
                <option key={size} value={size} className="bg-[#111] text-white">
                  {size}
                </option>
              ))}
            </select>
          </label>
        )}

        {colorOptions.length > 0 && (
          <label className="block">
            <span className="sr-only">{colorLabel}</span>
            <select
              aria-label={colorLabel}
              value={selectedColor}
              onChange={(event) => onColorChange(event.target.value)}
              disabled={disabled}
              className={selectClasses}
            >
              <option value="" disabled>
                {allLabel || colorLabel}
              </option>
              {colorOptions.map((color) => (
                <option key={color} value={color} className="bg-[#111] text-white">
                  {color}
                </option>
              ))}
            </select>
          </label>
        )}
      </div>
    </div>
  );
};

export default VariantSelectors;
